      const phoneInput = document.getElementById('customer_phone');
      function handleInput(e) {
        let value = e.value;

        if (value.length === 1 && value[0] !== "5") {
          e.value = "";
          return;
        }
        value = value.replace(/\D/g, "");
        if (value.length <= 3) {
          value = value.replace(/^(\d{0,3})/, "($1");
        } else if (value.length <= 6) {
          value = value.replace(/^(\d{3})(\d{0,3})/, "($1) $2");
        } else {
          value = value.replace(/^(\d{3})(\d{3})(\d{1,4})/, "($1) $2-$3");
        }

        e.value = value;
      }
